// SYNCED FROM: VidaReactNative/src/features/AddressVerification/utils/parseVerifyResponse.ts
// Keep in sync. See SYNC.md.
import type { LobVerifyResponse } from '../api/lobApi';
import type { Address } from '../types';

/**
 * Convert a Lob verification response into our internal `Address` shape.
 *
 * Lob's pre-assembled strings (eg primary_line) put secondary info (apt/unit)
 * on line 1, but we want it on line 2, so we assemble `addressLine1`
 * and `addressLine2` from the structured components
 */
export const parseVerifyResponse = (response: LobVerifyResponse): Address => {
  const c = response.components;

  const addressLine1 = [
    c.primary_number,
    c.street_predirection,
    c.street_name,
    c.street_suffix,
    c.street_postdirection,
  ]
    .filter((part): part is string => !!part)
    .join(' ');

  const addressLine2 = [
    c.secondary_designator,
    c.secondary_number,
    c.extra_secondary_designator,
    c.extra_secondary_number,
    c.pmb_designator,
    c.pmb_number,
  ]
    .filter((part): part is string => !!part)
    .join(' ');

  return {
    addressLine1,
    addressLine2: addressLine2 || undefined,
    city: c.city,
    state: c.state,
    zip: c.zip_code,
  };
};
